import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import TherapyPage from "@/pages/TherapyPage";
import ApplyPage from "@/pages/ApplyPage";
import PlaceholderPage from "@/pages/PlaceholderPage";
import TrainingPage from "@/pages/TrainingPage";
import HomePage from "@/pages/HomePage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Toaster position="bottom-right" />
        <div className="kh-scope min-h-screen flex flex-col">
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/therapy" element={<TherapyPage />} />
              <Route path="/apply" element={<ApplyPage />} />
              <Route path="/training" element={<TrainingPage />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/about" element={<PlaceholderPage eyebrow="About" title="About Kheiron." />} />
              <Route path="*" element={<TherapyPage />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
